import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort as faSorted } from '@fortawesome/pro-duotone-svg-icons';
import { faCircleInfo, faSort as faUnsorted } from '@fortawesome/pro-solid-svg-icons';
import { t } from 'react-switch-lang';
import style from '../../styles/Reports.module.scss';
import { DIRECTION } from '../../utils/Constants';
import Tooltip from '../Tooltip';

function getNextSortDescription(sortDirection) {
  switch (sortDirection) {
    case DIRECTION.DESCENDING:
      return t('Reports_SortColumn_ButtonDescription', { direction: t('Reports_SortColumn_Direction_Ascending') });
    case DIRECTION.ASCENDING:
    default:
      return t('Reports_SortColumn_ButtonDescription', { direction: t('Reports_SortColumn_Direction_Descending') });
  }
}

function renderSortIcon(sortDirection) {
  const size = 'sm';
  switch (sortDirection) {
    case DIRECTION.ASCENDING:
      return <FontAwesomeIcon className={style.sortIcon} icon={faSorted} size={size} />;
    case DIRECTION.DESCENDING:
      return <FontAwesomeIcon className={`${style.sortIcon} fa-swap-opacity`} icon={faSorted} size={size} />;
    default:
      return (
        <FontAwesomeIcon
          className={style.sortIcon}
          style={{ opacity: 0.4 }}
          icon={faUnsorted}
          size={size}
        />
      );
  }
}

function ColumnHeaderRenderer({ column, sortDirection, tooltip, isSelected, ariaLabel }) {
  const baseHeader = (
    <div
      className={`${tooltip ? style.infoColumnHeader : ''} ${style.sortColumnHeader}`}
      title={getNextSortDescription(sortDirection)}
      aria-label={`${column.name} -${ariaLabel ? ` ${ariaLabel} -` : ''}${tooltip && !ariaLabel ? ` ${tooltip} -` : ''} ${isSelected ? getNextSortDescription(sortDirection) : ''}`}
    >
      <div className={style.headerText}>
        <span>{column.name}</span>
        {tooltip && <FontAwesomeIcon className={style.infoIcon} icon={faCircleInfo} />}
      </div>
      {renderSortIcon(sortDirection)}
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip
        content={tooltip}
        active={isSelected}
      >
        {baseHeader}
      </Tooltip>
    );
  }
  return baseHeader;
}

export default ColumnHeaderRenderer;
